import { AvailableOperationStatus } from "../operations/available-operation-status";
import { AvailableOperationTypes } from "../operations/available-operation-types";
import { OperationRequest } from "../operations/operation-request";
import { Routes } from "../routes";
import { Strategy } from "./abstract-strategy";

export class OperationNOTEStrat extends Strategy {

  public hasCondition(request: OperationRequest): boolean {
    const availableStatus = [
      AvailableOperationStatus.ACTIVA,
      AvailableOperationStatus.PENDIENTE_ENTREGA,
      AvailableOperationStatus.NO_ENTREGADO
    ];
    const availableOperations = [
      AvailableOperationTypes.NOTE,
      AvailableOperationTypes.QERDS
    ]
    const isOperationNOTE = availableOperations.includes(request.operationType);
    const hasActiveStatus = availableStatus.includes(request.state);
    if (hasActiveStatus && isOperationNOTE && !request.hasError) {
      return true;
    }
    return false;
  }

  public setStrategy(request?: OperationRequest): void {
    this.pathToGo = Routes.NOTE;
  }
}
